module.exports = __webpack_public_path__ + "img/2fbdcab.jpg";